export default __webpack_public_path__ + "static/media/mikeycompressed.b9678205.jpg";